export const defaultColumns = [
  { label: "Status", value: "status" },
  { label: "Cod. Fatura", value: "number" },
  { label: "Valor. Total", value: "total_amount", className: "w-2/6" },
  { label: 'Data de abertura', value: 'opened_at' },
  { label: 'Data de fechamento', value: 'closed_at' },
  { label: "Qnt de Transações", value: "events_count" },
  { label: "Ações", value: "actions", className: "w-9" },
];
